module.exports = __webpack_public_path__ + "img/check.8be71a90.svg";